module.exports = __webpack_public_path__ + "img/github.ea0dc6d2.png";